// extracted by mini-css-extract-plugin
export default {"settings":"Preferences_settings__+Bqur"};